
<ngx-spinner></ngx-spinner>

<div class="toaster-container d-flex flex-column align-items-center justify-content-center">
<div *ngFor="let notification of notifications" [ngClass]="notification.type" class="my-1 toaster">
 
  <button mat-icon-button class="mx-3" (click)="removeNotification(notification)">
    <i class="ri-close-circle-line"></i>
  </button>
    <h5 class="me-3" [routerLink]="['/notifications/list']">{{notification.message}}</h5>
   
</div>
</div>
  <router-outlet></router-outlet>



